import { initDataTilt } from '../../utils/data-tilt.utils.js';

const TILT_MIN_WIDTH = 1034;
const mql = window.matchMedia(`(min-width: ${TILT_MIN_WIDTH}px)`);

function initTilt() {
  initDataTilt();
}

function destroyTilt() {
  const elements = document.querySelectorAll('[data-tilt]');
  elements.forEach((el) => {
    if (el.vanillaTilt) {
      el.vanillaTilt.destroy();
    }
  });
}

function handleBreakpoint(e) {
  if (e.matches) {
    initTilt();
  } else {
    destroyTilt();
  }
}

handleBreakpoint(mql);
mql.addEventListener('change', handleBreakpoint);
